<div class="card card-stretch h-100 rounded-0 context-menu">
    <div class="card-header p-3 d-flex justify-content-between border-bottom-0">
        <h5 class="card-title mb-0 font-weight-bolder">
            <img src="../../../../assets/common/images/Activities/LeaveRequest.svg" class="h-20px w-20px rounded mr-2" /> {{'TeamLeaveRequest'|localize}}
        </h5>
        <div *ngIf="!isEmpty && isLoaded" class="ml-auto cursor-pointer card-toolbar">
            <div class="font-weight-bolder text-primary cursor-pointer" (click)="viewall()">
                {{ 'ViewAll' | localize}}
            </div>
        </div>
    </div>

    <div class="card-body p-0 pb-3">

        <!--Empty state ui-->
        <div *ngIf="isLoaded && isEmpty">
            <div class="card h-350px">
                <div class="d-flex justify-content-center">
                    <div class="d-flex flex-column mt-20">
                        <img src="../../../../assets/common/images/new-dashboard/new-team-leave-request-ui.png" class="h-200px w-150px " />
                        <h6 class="text-muted text-center mt-5">{{'NoDataFounds'|localize}}</h6>
                    </div>
                </div>
            </div>

        </div>

        <div *ngIf="isEmpty && !isLoaded">
            <div *ngFor="let x of [1, 2, 3, 4]">

                <div class="row px-4">
                    <div class="col-md-2">

                        <ngx-shimmer-loading [width]="'100%'" [height]="'60px'"></ngx-shimmer-loading>


                    </div>

                    <div class="col-md-2">

                        <ngx-shimmer-loading [width]="'100%'" [height]="'60px'"></ngx-shimmer-loading>


                    </div>

                    <div class="col-md-2">

                        <ngx-shimmer-loading [width]="'100%'" [height]="'60px'"></ngx-shimmer-loading>


                    </div>

                    <div class="col-md-2">

                        <ngx-shimmer-loading [width]="'100%'" [height]="'60px'"></ngx-shimmer-loading>


                    </div>
                    <div class="col-md-2">

                        <ngx-shimmer-loading [width]="'100%'" [height]="'60px'"></ngx-shimmer-loading>


                    </div>

                    <div class="col-md-2">

                        <ngx-shimmer-loading [width]="'100%'" [height]="'60px'"></ngx-shimmer-loading>


                    </div>

                </div>

            </div>
        </div>

        <div class="overflow">
            <div *ngIf="!isEmpty && isLoaded">
                <div class="row px-4">

                    <div class="col-md-12">
                        <div id="LeaveRequest-data-table">
                            <p-table [value]="this.userLeaveData" [rows]="5" [paginator]="true" [alwaysShowPaginator]="false">
                                <ng-template pTemplate="header">
                                    <tr [ngClass]="'textcolor'">
                                        <th>{{'Members'|localize}}</th>
                                        <th>{{'LeaveCategory'|localize}}</th>
                                        <th>{{'TimeOffSubmittedOn'|localize}}</th>
                                        <th>{{'LeaveDuration'|localize}}</th>
                                        <th>{{'Reason'|localize}}</th>
                                        <th class="text-center">{{'Status'|localize}}</th>
                                    </tr>
                                </ng-template>
                                <ng-template pTemplate="body" let-AddAwayTimeGetAllDto>
                                    <tr [ngClass]="'textcolor bg-hover-gray-100'"  id="pointerClassOrg">



                                        <td>
                                            <div class="d-flex">
                                                <div class="d-flex align-items-center">
                                                    <div class="d-flex justify-content-center align-items-end border border-light rounded w-100">
                                                        <img [src]="AddAwayTimeGetAllDto.userImage" class="p-1 w-35px h-35px rounded" id="profimgsize">
                                                    </div>

                                                </div>
                                                <div class="d-flex flex-column ml-3 justify-content-center">
                                                    <div class="font-weight-bold" pTooltip="{{AddAwayTimeGetAllDto.userName }}" [tooltipDisabled]="DisableTooltip(AddAwayTimeGetAllDto.userName, 16)" tooltipPosition="bottom">{{ AddAwayTimeGetAllDto.userName | slice:0:15}}{{AddAwayTimeGetAllDto.userName.length > 15 ? '...' : '' }}</div>
                                                    <div class="font-size-14">
                                                        <small pTooltip="{{ (AddAwayTimeGetAllDto.userRole) ? AddAwayTimeGetAllDto.userRole.toString().replace(',' , ', ') : '-' }}"
                                                               tooltipPosition="bottom">
                                                            {{ (AddAwayTimeGetAllDto.userRole?.toString().replace(',' , ', ')).slice(0, 30) }}{{
 AddAwayTimeGetAllDto.userRole?.toString().replace(','
      , ', ').length > 30 ? '...' : ''
                                                            }}
                                                        </small>

                                                    </div>
                                                </div>
                                            </div>
                                        </td>
                                        <td>
                                            <div class="d-flex">
                                                <div class="d-flex align-items-center">
                                                    <div class="d-flex justify-content-center align-items-center bg-gray-100 rounded w-100" tyle="width: 40px; height: 40px;">
                                                        <container-element [ngSwitch]="AddAwayTimeGetAllDto.awayTimeType">
                                                            <img *ngSwitchCase="1" class="w-35px h-35px img-fluid rounded bg-primary-o-40 p-1"
                                                                 src="../../../../assets/common/images/time-off/Conference.svg">
                                                            <img *ngSwitchCase="2" class="w-35px h-35px img-fluid rounded bg-primary-o-40 p-1"
                                                                 src="../../../../assets/common/images/time-off/Parental leave.svg">
                                                            <img *ngSwitchCase="3" class="w-35px h-35px img-fluid rounded bg-primary-o-40 p-1"
                                                                 src="../../../../assets/common/images/time-off/Business trip.svg">
                                                            <img *ngSwitchCase="4" class="w-35px h-35px img-fluid rounded bg-primary-o-40 p-1"
                                                                 src="../../../../assets/common/images/time-off/Vacation.svg">
                                                            <img *ngSwitchCase="5" class="w-35px h-35px img-fluid rounded bg-primary-o-40 p-1"
                                                                 src="../../../../assets/common/images/time-off/Unpaid leave.svg">
                                                            <img *ngSwitchCase="6" class="w-35px h-35px img-fluid rounded bg-primary-o-40 p-1"
                                                                 src="../../../../assets/common/images/time-off/Sick.svg">
                                                            <img *ngSwitchCase="7" class="w-35px h-35px img-fluid rounded bg-primary-o-40 p-1"
                                                                 src="../../../../assets/common/images/time-off/Casual-leave.svg">
                                                            <img *ngSwitchCase="8" class="w-35px h-35px img-fluid rounded bg-primary-o-40 p-1"
                                                                 src="../../../../assets/common/images/time-off/humanpictos.svg">
                                                            <img *ngSwitchCase="9" class="w-35px h-35px img-fluid rounded bg-primary-o-40 p-1"
                                                                 src="../../../../assets/common/images/time-off/interface.svg">
                                                            <img *ngSwitchCase="10" class="w-35px h-35px img-fluid rounded bg-primary-o-40 p-1"
                                                                 src="../../../../assets/common/images/time-off/minutes.svg">
                                                        </container-element>

                                                    </div>
                                                </div>
                                                <div class="d-flex flex-column ml-3">
                                                    <div class="font-weight-bold">
                                                        {{
                                                    AddAwayTimeGetAllDto.awayTimeTypeName  | localize
                                                        }}
                                                    </div>

                                                </div>
                                            </div>
                                        </td>
                                        <td>

                                            {{ AddAwayTimeGetAllDto.createdDateTime | date:dateFormat}}

                                        </td>
                                        <td>
                                            {{ AddAwayTimeGetAllDto.fromDate | date:dateFormat}}  -  {{ AddAwayTimeGetAllDto.toDate | date:dateFormat}}
                                        </td>
                                        <td>
                                            <div class="d-flex flex-column">
                                                <div class="leave-away-time-reason my-1">
                                                    <span pTooltip="{{AddAwayTimeGetAllDto.description}}" [tooltipDisabled]="false" tooltipPosition="bottom">
                                                        {{
                                                AddAwayTimeGetAllDto.description | slice:0:25
                                                        }}{{AddAwayTimeGetAllDto.description?.length > 25 ? '...' : '' }}
                                                    </span>
                                                </div>
                                            </div>
                                        </td>
                                        <td class="text-center">



                                            <div class="label label-outline-secondary ml-12 rounded-pill h-28px w-75px label-inline border  bg-white  justify-content-center">

                                                <span class="label label-dot" [ngClass]="{'label-success': AddAwayTimeGetAllDto.addTimeStatus == 1,'label-warning': AddAwayTimeGetAllDto.addTimeStatus == 2,'label-danger': AddAwayTimeGetAllDto.addTimeStatus == 3,'label-orange': AddAwayTimeGetAllDto.addTimeStatus == 4}"></span>
                                                <span *ngIf="AddAwayTimeGetAllDto.addTimeStatus == 1" class="ml-2">{{'Approved'|localize}}</span>
                                                <span *ngIf="AddAwayTimeGetAllDto.addTimeStatus == 2" class="ml-2">{{'Pending'|localize}}</span>
                                                <span *ngIf="AddAwayTimeGetAllDto.addTimeStatus == 3" class="ml-2">{{'Rejected'|localize}}</span>
                                                <span *ngIf="AddAwayTimeGetAllDto.addTimeStatus == 4" class="ml-2">{{'Overdue'|localize}}</span>

                                            </div>
                                        </td>
                                    </tr>
                                </ng-template>
                            </p-table>
                        </div>
                    </div>

                </div>
            </div>

        </div>
    </div>
</div>
